import {Company} from '../_data/admin/company';
import {Branch} from '../_data/admin/branch';
import {IfsRequest} from '../_data/reports/ifs/ifs-request';
import {JwtToken, RawDecodedTokenPair, TokenPair} from '../_data/admin/jwt-token';
import {ConsumerRequestReport} from '../consumer-services/reports/ifs-report/ifs-report.component';
import {UserObject} from '../_data/admin/logged-in-user';
import {ElementRef} from '@angular/core';
import {ChangePasswordError} from '../_data/admin/change-password-error';
import {Hawk} from '../_data/reports/ifs/hawk';
import {ConsumerRequestConsumer} from '../_data/reports/consumer/consumer-request';
import {BusinessReport} from '../_data/reports/business/response/business';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {UserDetails} from '../_data/mfa/mfa-user-details';

export function isCompanyBranch(v: any): v is {company: Company; branch: Branch} {
  return v?.hasOwnProperty('company');
}

export function isIfsRequest(v: any): v is IfsRequest {
  return v?.hasOwnProperty('ifs');
}

export function isConsumerRequestReport(v: any): v is ConsumerRequestReport {
  return v?.hasOwnProperty('req') && v?.hasOwnProperty('report') && v?.report?.hasOwnProperty('consumers');
}

export function isConsumerRequestConsumer(v: any): v is ConsumerRequestConsumer {
  //Could not find a property that was missing from v
  return !['suffix', 'firstName', 'lastName', 'middleName', 'subjectIdentifier', 'addresss', 'employments', 'creditCards', 'dob', 'phones', 'sin']
    .find(prop => !v.hasOwnProperty(prop));
}

export function isJwtToken(v: any): v is JwtToken<any> {
  return v?.hasOwnProperty('token');
}

export function isUserObject(v: any): v is UserObject {
  return v?.hasOwnProperty('company') && v.hasOwnProperty('productIndicator');
}

export function isElementRef(v: any): v is ElementRef {
  return v?.hasOwnProperty('nativeElement');
}

export function isObject(v: any): v is { [s: string]: any } {
  return v?.constructor === Object;
}

export function isChangePasswordError(v: any): v is ChangePasswordError {
  return v?.hasOwnProperty('newPassword') || v?.hasOwnProperty('password');
}

export function isHrfa(v: any): v is Hawk {
  return (v?.hasOwnProperty('alerts') && v?.hasOwnProperty('hawkCodes') && v?.hasOwnProperty('hawkHits')) || v?.hasOwnProperty('hawkMessages');
}

export function isBusinessReport(v: any): v is BusinessReport {
  return !['auditSerialNum', 'bid', 'bizAccounts', 'bizAddresses'].find(prop => !v.hasOwnProperty(prop));
}

export function isCompany(v: any): v is Company {
  const c = v as Company;
  return c?.companyName !== undefined && c?.creationDate !== undefined;
}

export function isFormGroup(control: AbstractControl): control is UntypedFormGroup {
  return !!(control as UntypedFormGroup)?.controls;
}

export function isTokenPair(v: any): v is TokenPair<any,any> {
  return  v?.hasOwnProperty( 'full') && v?.hasOwnProperty( 'refresh');
}

export function isRawDecodedTokenPair(v: any): v is RawDecodedTokenPair<UserDetails> {
    return  v?.hasOwnProperty( 'token') && v?.hasOwnProperty( 'decodedToken');
}
